<template>
  <div class="GoodPhoto">
    <!-- 整洁度差工地快照 -->
    <div class="title">
      <div class="title_days">整洁度优工地快照</div>
    </div>
    <!--swiper-no-swiping 禁止拖动  -->
    <div
      class="swiper-container"
      id="swiper-container-GoodPhoto2"
      v-if="swiper_list.length > 0"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, i) in swiper_list"
          :key="i"
          :data-href="sliteItem(item)"
          @click="handleClickSlide(item)"
        >
          <!-- :id="i" -->
          <div class="swiper-slide-img">
            <img :src="pathUrl + item.ws_photo" alt="" />
            <!-- <img :src="item.ws_photo" alt="" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
import { GetWscleanbadpic, GetWscleangoodpic } from "../../api/adminBoard";
import { urlConfig } from "@/config/config";
export default {
  name: "GoodPhoto",
  props: {
    bc_id: {},
    showDrawer: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      mySwiper: "",
      swiper_list: [],
      swiper_list1: [
        {
          ws_photo:
            "https://ai.ccom.com.cn/files/picture/snapshot/snapshotpicture?filePath=/snapshot/factory/2025-05-19/16314_1747612825755.png",
        },
        {
          ws_photo:
            "https://ai.ccom.com.cn/files/picture/snapshot/snapshotpicture?filePath=/snapshot/factory/2025-05-19/16388_1747614044234.png",
        },
        {
          ws_photo:
            "https://ai.ccom.com.cn/files/picture/snapshot/snapshotpicture?filePath=/snapshot/factory/2025-05-19/16447_1747612460411.png",
        },
        {
          ws_photo:
            "https://ai.ccom.com.cn/files/picture/snapshot/snapshotpicture?filePath=/snapshot/factory/2025-05-19/16489_1747612240034.png",
        },
      ],
      pathUrl:
        urlConfig.baseUrl + "/files/picture/snapshot/snapshotpicture?filePath=",
      record: {},
      queryParam: { bc_id: "" },
    };
  },
  created() {},
  mounted() {
    this.loadData();
  },
  updated() {
    if (this.mySwiper) {
      this.$nextTick(() => {
        this.mySwiper.loopDestroy();
        this.mySwiper.loopCreate();
      });
    }
  },
  watch: {
    bc_id(NValue, OValue) {
      this.queryParam.bc_id = NValue;
      this.loadData();
      // console.log(this.queryParam.bc_id);
    },
  },
  methods: {
    initSwiper() {
      let vm = this;
      //   this.mySwiper = new Swiper("#swiper-container", {
      this.mySwiper = new Swiper("#swiper-container-GoodPhoto2", {
        // effect: "coverflow",
        // slidesOffsetBefore: 20, //偏移量

        centeredSlides: true,
        loop: true, // 循环模式选项 当播放到最后一张图片后，点击按钮是否会继续轮播
        // initialSlide: 1,
        direction: "vertical", // 垂直切换
        slidesPerView: 3, //一次显示2个
        // slidesPerGroup: 1, //一次往前移一个
        spaceBetween: 4,
        // slidesPerColumn: 2, //多行 —— 一屏显示2行
        // loopedSlides: 1,
        // loopFillGroupWithBlank: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: true,
        autoplay: {
          //   delay: 1000 * 60, // 自动播放的间隔时间，单位ms，默认3000ms
          delay: 2000,
          disableOnInteraction: false, // 用户操作后是否停止自动播放，默认为true，即停止。改为false，表示不会停止自动播放
        },
        // width: 350,
        //设置断点宽度
        breakpoints: {
          // 1024: {
          //   width: 200,
          // },
          768: {
            // width: 290, //取消width，恢复自适应
          },
        },
        on: {
          click: function (sw) {
            let sw_id = sw.target.src;
            // console.log("整洁度差工地快照", sw_id);
            vm.swiper_list.forEach((element) => {
              if (sw_id.indexOf(element.ws_photo) != -1) {
                vm.record.ws_id = element.ws_id;
                vm.record.ws_name = element.ws_name;
                console.log("vm.record.ws_id", vm.element);
                vm.$emit("record", vm.record);
                vm.showDrawer();
              }
            });
          },
        },
      });
    },
    // 开启loop模式，拿不到第二轮首页数据
    handleClickSlide(index) {
      // console.log(index);
    },
    sliteItem(item) {
      //   console.log(item);//可以获取所有的数据
    },
    async loadData() {
      this.swiper_list = [];
      const orderParam = ["bc_id"];
      const param = Object.assign({}, this.queryParam);
      const requestParameters = this.$order(param, orderParam);
      const params = {
        ...requestParameters,
        verify: this.$verify(requestParameters, orderParam),
      };
      await GetWscleangoodpic(params)
        .then((res) => {
          // console.log("整洁度差工地快照", res);
          // this.swiper_list = res.data;
          // let index = `-` + Math.floor(this.swiper_list1.length / 2) - 1;
          if (res.data.length > 0) {
            this.swiper_list = res.data.slice(Math.floor(res.data.length / 2));
          }

          console.log("this.swiper_list222", this.swiper_list);
        })
        .then(() => {
          this.initSwiper(); //不能放在created里
        });
    },
  },
};
</script>

<style lang="less" scoped>
.GoodPhoto {
  width: 100%;
  height: 100%;
  .title {
    width: 100%;
    height: 5%;
    color: #66ffff;
    text-align: left;
    padding-left: 10px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title_days {
      width: 50%;
      img {
        width: 8%;
        height: 40%;
      }
    }
  }
  .swiper-container {
    width: 100%;
    height: 95%;
    .swiper-slide {
      // background-color: pink;
      // margin: 10px 0;
      .swiper-slide-img,
      img {
        // margin: 10px 0;
        // border: 1px solid #66ffff;
        height: 100%;
        width: 100%;
        cursor: pointer;
      }
    }
  }
  // 如果想要两边的图片显示时缩小加上一下css代码
  // 默认中间的图片会带有类名 : .swiper-slide-acive;
  // 默认中间的图片的上一张图片会带有类 名:  .swiper-slide-prev ;
  // 默认中间的图片的下一张会带有类名: .swiper-slide-next ;.
  // .swiper-slide-next {
  //   transform: scale(0.8);
  // }
  // .swiper-slide-prev {
  //   transform: scale(0.8);
  // }
}
</style>
